module.exports = __webpack_public_path__ + "static/wind-alert-c75c8ead95ec871fbee790e47dd5f2f5.mp4";